import "./common/locoscroll";
import "./common/topmirror";
import "./common/menu";
import "./common/marq";
import "./common/manifest";
import "./common/noise";
import "./common/iconic";
import "./common/showcase";
import "./common/team";
import "./common/housing";
import "./common/footer";

// about page
import "./common/trusted";
import "./common/people";



// project page
import "./common/projects";
import "./common/project";

// workflow page
import "./common/collaboration";
import "./common/process";

import Sketch from './3d/canvas.js'
import Sketch1 from './3d/bluebackground'


if(!window.isMobile && document.querySelector('#bluebackground')){
    let canvas = new Sketch1({
        dom: document.querySelector("#bluebackground")
    });
    window.canvas3d = canvas;
}

if(document.querySelector('.p404__images'))  document.querySelector('.p404__images').classList.remove('is-hidden')



